import axios from 'axios';

const ENDPOINTS = {
  personalInfo: '/api/texts/lk-update-personal-info/',
};

export const personalInfoRequest = async () => {
  try {
    const { data } = await axios.get(ENDPOINTS.personalInfo);
    if (data) {
      return data;
    }
  } catch (err) {
    console.error(err);
  }
  return {};
};
